import "./bootstrap.scss";

const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");
window.bootstrap = bootstrap;

export function initTooltips(root: ParentNode = document) {
    root.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"][data-bs-title]:not([data-bs-title=""])').forEach(
        (el) => {
            bootstrap.Tooltip.getOrCreateInstance(el);
        }
    );
}

document.addEventListener("DOMContentLoaded", () => initTooltips());
